/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ShapeRectHIcon64Regular = forwardRef('ShapeRectHIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 21.5C6 15.701 10.701 11 16.5 11h31C53.299 11 58 15.701 58 21.5v21C58 48.299 53.299 53 47.5 53h-31C10.701 53 6 48.299 6 42.5v-21ZM16.5 14A7.5 7.5 0 0 0 9 21.5v21a7.5 7.5 0 0 0 7.5 7.5h31a7.5 7.5 0 0 0 7.5-7.5v-21a7.5 7.5 0 0 0-7.5-7.5h-31Z" })));
});
